import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { CustomLogoutComponent } from './custom-logout.component';

@NgModule({
  declarations: [CustomLogoutComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        LogoutPageComponent: {
          component: CustomLogoutComponent,
        },
      },
    }),
  ],
})
export class CustomLogoutModule {}
